import { render } from "./Select-Cartera.vue?vue&type=template&id=96a3991c&scoped=true"
import script from "./Select-Cartera.vue?vue&type=script&lang=js"
export * from "./Select-Cartera.vue?vue&type=script&lang=js"

import "./Select-Cartera.vue?vue&type=style&index=0&id=96a3991c&lang=css"
import "./Select-Cartera.vue?vue&type=style&index=1&id=96a3991c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96a3991c"]])

export default __exports__